import React from 'react';
import PropTypes from 'prop-types';
import Field from 'components/grid/table/components/fields/field';
import { format } from 'date-fns';
import { isFunction } from 'lodash';

const DateField = ({ children, ...props }) => (
  <Field {...props}>
    {({ value, defaultValue, data }) => {
      const formattedDate = format(new Date(value), props.format);

      if (isFunction(children)) {
        return children({
          data,
          value: formattedDate,
          defaultValue,
        });
      }

      if (value && value !== defaultValue) {
        return formattedDate;
      }

      return defaultValue;
    }}
  </Field>
);

DateField.propTypes = {
  ...Field.propTypes,
  format: PropTypes.string,
};

DateField.defaultProps = {
  ...Field.defaultProps,
  format: 'dd.MM.yyyy',
};

export default DateField;
